// Weekender "Open Pockets" stop-motion loops.
// Ported 1:1 from the concept's own timing/flow logic — NOT a generic flat
// interval. Real stop-motion photography, not scroll-driven: each sequence
// just plays on a steady loop once its section scrolls into view, pauses
// again once it scrolls out, and holds longer on specific frames (the final
// "fully packed" frame, and — for the Main Compartment sequence — the
// fully-open frame) before continuing, exactly like the concept.
(function(){
  const urlsEl = document.getElementById('pdpPocketsFrameUrls');
  if(!urlsEl) return;
  let urls;
  try{ urls = JSON.parse(urlsEl.textContent); } catch(e){ return; }

  const FRAME_COUNT = 16;
  const FRAME_MS = 260;        // slower, deliberate stop-motion cadence, not smoothed video
  const HOLD_LAST_MS = 1400;   // longer pause on the final "fully packed" frame before it loops

  function makeLoop(stageId, frameElId, frameUrls, opts){
    const stage = document.getElementById(stageId);
    const frameEl = document.getElementById(frameElId);
    if(!stage || !frameEl || !frameUrls || !frameUrls.length) return;

    let preloaded = false;
    function preloadFrames(){
      if(preloaded) return;
      preloaded = true;
      frameUrls.forEach(function(u){ const im = new Image(); im.src = u; });
    }

    const tags = stage.querySelectorAll('.pdp-pockets-tag');
    let index = 0;
    let timer = null;

    function advance(){
      index++;
      if(index >= FRAME_COUNT){
        index = 0;
        frameEl.src = frameUrls[index];
        timer = setTimeout(advance, HOLD_LAST_MS);
        return;
      }
      frameEl.src = frameUrls[index];
      const frameNum = index + 1;
      let holdMs = FRAME_MS;
      if(frameNum === FRAME_COUNT) holdMs = HOLD_LAST_MS;
      else if(opts && opts.holdFrame === frameNum) holdMs = opts.holdMs;
      timer = setTimeout(advance, holdMs);
    }

    function start(){
      if(timer) return;
      timer = setTimeout(advance, FRAME_MS);
    }
    function stop(){
      if(timer){ clearTimeout(timer); timer = null; }
    }

    const observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          start();
          tags.forEach(function(tag){ tag.classList.add('in-view'); });
        } else {
          stop();
        }
      });
    }, { threshold:0.3 });
    observer.observe(stage);

    const preloadObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          preloadFrames();
          preloadObserver.disconnect();
        }
      });
    }, { rootMargin: '800px 0px' });
    preloadObserver.observe(stage);
  }

  makeLoop('pdpLuggageStage', 'pdpLuggageFrame', urls.luggage, { holdFrame:12, holdMs:1800 });
  makeLoop('pdpPocketsStage', 'pdpPocketsFrame', urls.pockets, null);
})();